import { HeroBox, HeroContent } from "./hero.styles";

type Props = {
  imgSrc: string;
  children?: string | React.ReactNode;
  className?: string;
  hAlign?: "start" | "center" | "end";
  vAlign?: "start" | "center" | "end";
};

/**
 * A hero section, to be used on top of a webpage.
 * This component provides base styles for the section background and content positioning
 * Content layout is delegated to children.
 */
const Hero: React.FC<Props> = ({
  imgSrc,
  children,
  className,
  hAlign,
  vAlign,
}) => (
  <HeroBox bgUrl={imgSrc} className={className}>
    <HeroContent
      hAlign={hAlign ?? "start"}
      vAlign={vAlign ?? "start"}
      className="p-4"
    >
      {children}
    </HeroContent>
  </HeroBox>
);

export default Hero;
